module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/029-1985f31ac5e112d0d8f80802a6a66c7d.jpg";